<ng-template>
  <zwi-books [oldTestament]="oldTestament" [newTestament]="newTestament"></zwi-books>
</ng-template>
<div (click)="open()" class="js-menu-button" #menuTarget>
  @if (book) {
    <button mat-button><span>{{ book.name }}</span><mat-icon iconPositionEnd>arrow_drop_down</mat-icon></button>
  } @else {
    <button mat-button><span>Book</span><mat-icon iconPositionEnd >arrow_drop_down</mat-icon></button>
  }
</div>
